import { render, staticRenderFns } from "./_OpenButton.vue?vue&type=template&id=d95fa2b4"
import script from "./_OpenButton.vue?vue&type=script&lang=ts"
export * from "./_OpenButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports